import React, { useEffect, useState } from 'react';
import { MutationStatus } from 'react-query';
import LastUpdatedDateTimeStamp from 'web-library/components/draft-date-time-stamp/LastUpdatedDateTimeStamp';
import { useGetRetrieveAuditSettings } from '../../../api-refactored/audit-settings/useGetRetrieveAuditSettings';

interface LastUpdatedDateTimeAuditSettingsProps {
  reportType: string;
  status: MutationStatus;
}

const LastUpdatedDateTimeAuditSettings = ({
  reportType,
  status,
}: LastUpdatedDateTimeAuditSettingsProps) => {
  const [isSuccessRetrieveAuditSettings, setIsSuccessRetrieveAuditSettings] = useState<boolean>(
    false
  );

  const { data: auditSettingsData, refetch } = useGetRetrieveAuditSettings({
    reportType,
    onSuccess: () => {
      setIsSuccessRetrieveAuditSettings(true);
    },
  });

  useEffect(() => {
    if (status === 'success') {
      refetch();
    }
  }, [refetch, status]);

  if (
    isSuccessRetrieveAuditSettings &&
    auditSettingsData?.lastUpdatedDateTime &&
    auditSettingsData?.lastUpdatedBy
  )
    return (
      <LastUpdatedDateTimeStamp
        lastUpdatedInfo={{
          lastUpdatedTime: auditSettingsData?.lastUpdatedDateTime,
          name: auditSettingsData?.lastUpdatedBy,
        }}
      />
    );
  return <></>;
};

export default LastUpdatedDateTimeAuditSettings;
